import { AuthContext, AuthProvider } from './AuthProvider';
import { useAuthProvider } from './useAuthProvider';
import { createContext, useContext } from 'react';
import { AuthContextType } from './types';

// カスタムフックの作成
export const useAuth = () => useContext(AuthContext);

export {
  AuthContext,
  AuthProvider,
  useAuthProvider
};

export type {
  AuthContextType
}; 